import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth.jsx";

const ProtectedRoute = ({ children }) => {
  const { admin, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center">
        <div className="text-[#5C4F42] font-serif text-xl">Ачааллаж байна...</div>
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
};

export default ProtectedRoute;
